import { type FormItemLayout } from './FormItem.tsx';

/*
 * Layout preconfezionati del FormItem, uno per caso d'uso specifico.
 */

/**
 * FormItem di uno `SwitchInput` con titolo e descrizione nel children, dentro
 * una `SwitchEvidenceCard`: il label visivo del FormItem è ridondante, quindi
 * viene nascosto (resta nel DOM per l'accessibilità) e si azzerano lo spazio
 * del label e il margine dell'help. Solo per questo caso, non per ogni switch.
 */
export const SWITCH_EVIDENCE_CARD_LAYOUT: FormItemLayout = {
  hideVisualLabel: true,
  removeLabelSpace: true,
  removeHelpMargin: true,
};

/**
 * FormItem di una `CheckboxInput` secondaria annidata in una
 * `SwitchEvidenceCard`, sotto lo switch principale (es. opzione dipendente
 * con testo proprio). Stessa resa della variante switch, al momento,
 * ma è un caso d'uso distinto e libero di divergere.
 */
export const CHECKBOX_EVIDENCE_CARD_LAYOUT: FormItemLayout =
  SWITCH_EVIDENCE_CARD_LAYOUT;
